import { toBaseProductType } from '@/collection/entity/CollectionType';
import { BaseCollectionItem } from '@/drive/entities/DriveItem/BaseCollectionItem';
import { CarbonProjectItem } from '@/drive/entities/DriveItem/CarbonProjectItem';
import { CollectionSubscriptionItem } from '@/drive/entities/DriveItem/CollectionSubscriptionItem';
import { DriveItem } from '@/drive/entities/DriveItem/DriveItem';
import { FolderItem } from '@/drive/entities/DriveItem/FolderItem';
import { ProductItem } from '@/drive/entities/DriveItem/ProductItem';
import { SpectrumItem } from '@/drive/entities/DriveItem/SpectrumItem';
import { UrlItem } from '@/drive/entities/DriveItem/UrlItem';
import { formatItemsCount } from '@/drive/helpers/formatItemsCount';
import { DiamondKind } from '@/product/entity/Diamond';
import { getProductTypeDisplayName } from '@/product/helpers/getProductTypeDisplayName';

export function isLabGrownProduct(driveItem?: DriveItem): boolean {
  return driveItem instanceof ProductItem && Boolean(driveItem.labGrown);
}

export function getProductKind(driveItem?: DriveItem): Nullable<DiamondKind> {
  if (driveItem instanceof ProductItem) {
    return driveItem.kind ?? null;
  } else {
    return null;
  }
}

export function getGridItemMeta(driveItem?: DriveItem, isOwner = false): string {
  const type = getGridItemType(driveItem, isOwner);

  if (driveItem instanceof FolderItem || driveItem instanceof BaseCollectionItem) {
    return withItemsCount(type, driveItem.count);
  }

  return type;
}

export function getGridItemType(driveItem?: DriveItem, isOwner = false): string {
  if (driveItem instanceof UrlItem) {
    return 'Link';
  }

  if (driveItem instanceof CarbonProjectItem) {
    return 'Carbon Project';
  }

  if (driveItem instanceof ProductItem || driveItem instanceof SpectrumItem) {
    return getProductTypeDisplayName(driveItem.productType);
  }

  if (driveItem instanceof FolderItem) {
    return 'Folder';
  }

  if (driveItem instanceof BaseCollectionItem) {
    const productType = getProductTypeDisplayName(toBaseProductType(driveItem.collectionType));
    const isFollowed = isOwner && driveItem instanceof CollectionSubscriptionItem;

    return isFollowed ? `Followed ${productType} Collection` : `${productType} Collection`;
  }

  return '';
}

function withItemsCount(label: string, count?: Nullable<number>): string {
  if (count === null || count === undefined) {
    return label;
  }

  return `${label}, ${formatItemsCount(count)}`;
}
